import { useState } from "react";
import { ErrorLbl, Input, InputContainer, InputLbl } from "./styles";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/lib/utils";

interface IInputLabel {
  label?: string;
  placeholder?: string;
  value: string;
  name?: string;
  setValue: (value: string) => void;
  required?: boolean;
  error?: boolean;
  errorMessage?: string;
  readonly?: boolean;
}

export const InputPassword: React.FC<IInputLabel> = ({
  label,
  placeholder,
  setValue,
  value,
  name,
  required = false,
  error = false,
  errorMessage = "Inválido.",
  readonly = false,
}) => {
  const [showText, setShowText] = useState(false);
  const [type, setType] = useState<string>("password");

  const handleToggleShowText = () => {
    setShowText((prev) => !prev);
    setType((prev) => (prev === "password" ? "text" : "password"));
  };

  return (
    <InputLbl className="relative">
      <span className="lbl">{label}</span>
      <InputContainer
        className={cn("h-[40px] box-border", {
          "-mt-3": label === undefined,
        })}
      >
        <Input
          type={type}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          required={required}
          name={name}
          readOnly={readonly}
          maxLength={25}
          style={{
            width: "100%",
            border: error ? "1px solid red" : "1px solid black",
            outline: "none",
          }}
        />
        {showText ? (
          <Eye
            size={16}
            onClick={handleToggleShowText}
            className="absolute cursor-pointer right-0 mr-3"
          />
        ) : (
          <EyeOff
            size={16}
            onClick={handleToggleShowText}
            className="absolute cursor-pointer right-0 mr-3"
          />
        )}
      </InputContainer>

      {error && (
        <ErrorLbl className="absolute left-0 bottom-0 -mb-5 mobile:-mb-4">
          {errorMessage}
        </ErrorLbl>
      )}
    </InputLbl>
  );
};
